import { SpecialTreatment } from "../tools/filter";

const getters = {
  getUser: (state) => {
    let data = localStorage.getItem("user");
    data = JSON.parse(data);
    if (data) {
      state.user = data;
      localStorage.setItem("user", JSON.stringify(data));
    } else {
      state.user = {};
      localStorage.removeItem("user");
    }
    return state.user;
  },
  getWC: (state) => {
    return state.wc;
  },
  getChainSystemInfo: ({ chainSystemInfo }) => {
    return chainSystemInfo;
  },
  gasFeeConfigsFxInfo: ({ chainSystemInfo }) => {
    return (
      chainSystemInfo.gasFeeConfigs.find(
        (elem) => elem.denom.toUpperCase() === "FX"
      ) || {
        denom: "FX",
        gas: "0",
        gasPrice: "0",
      }
    );
  },
  gasFeeConfigsUsdtInfo: ({ chainSystemInfo }, rootState) => {
    return (
      chainSystemInfo.gasFeeConfigs.find(
        (elem) =>
          elem.denom.toUpperCase() ===
          SpecialTreatment.getPairRearVal(
            rootState.getQueryPairInfo.pair
          ).toUpperCase()
      ) || {
        denom: SpecialTreatment.getPairRearVal(rootState.getQueryPairInfo.pair),
        gas: "0",
        gasPrice: "0",
      }
    );
  },
  getFeeRateInfo: ({ chainSystemInfo }) => {
    return chainSystemInfo.feeRate;
  },
};

export default getters;
